import { ItemHeader } from '@adotel/components'

import { getTranslate } from '../../localization'
import useStyles from './styles'

/**
 * The back affordance for the promotion builder — shown on CREATE only; editing an existing
 * promotion gets the standard Breadcrumb instead.
 *
 * Uses the LIBRARY `ItemHeader`, not a portal-local copy. The portal previously carried a fork
 * of it whose body was near-identical to the library's; that fork and the six back-button
 * wrappers that motivated it have been deleted.
 *
 * **The text is translated HERE, by the portal, and passed in already translated.** That is what
 * makes the library component safe to use. `ItemHeader` calls the LIBRARY's `getTranslate`
 * internally, against the library's own dictionary — 318 entries against the portal's 2,641 —
 * and 'Promotions' is not one of them. Passing the raw key would render English inside a Persian
 * page, silently, because `getTranslate` falls back to its input on a miss.
 *
 * That same fallback is what makes pre-translating work: the library receives Persian text, finds
 * no entry keyed by it (its dictionary is keyed on ENGLISH), and returns it untouched. In English
 * the library's dictionary is literally `{}`, so it is an identity function either way.
 *
 * The rule, for the next person: pass library components text that is already translated. Never
 * rely on a library component to reach the portal's dictionary — it cannot.
 */
const PromotionBuilderBackButton = () => {
  const classes = useStyles()
  return (
    <div className={classes.backHeader}>
      <ItemHeader text={getTranslate('Promotions')} />
    </div>
  )
}

export default PromotionBuilderBackButton
